import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type MapSwiftlaneUserRequest = {
  swiftlaneUserId: string
  userId: string
}

const mapSwiftlaneUser = async (data: MapSwiftlaneUserRequest) => {
  const response = await authAPI.post('/swiftlane/users/map', data)
  return response.data
}

export const useMapSwiftlaneUser = () =>
  useMutation({
    mutationFn: mapSwiftlaneUser,
  })
